import React, { Component, Fragment } from "react";
import api from "../../../services/api";
import utils from "../../../utils/utilsGraficos";
import SelectCampo from "../Relatorio/Grafico/SelectCampo";
import SelectModalidade from "../Relatorio/Cursos/SelectCampo";
import Chart from "react-apexcharts";
import Select from "../Relatorio/Grafico/Select";

export default class Dashboard extends Component {

    constructor(props) {
        super(props);

        this.state = {
            mes: "Anual",
            modalidade: "Todas",
            unidade: "Todas",
            metas: [],
            selectCampo: 0,
            nomeCampo: "numTurmas",
            horaAlunoProximosAnos: [],
            series: [
                {
                    name: "Pago",
                    data: []
                },
                {
                    name: "Gratuidade Regimental",
                    data: []
                },
                {
                    name: "Gratuidade Não-Regimental",
                    data: []
                }
            ],
            options: {
                chart: {
                    height: 350,
                    type: 'line',
                    dropShadow: {
                        enabled: true,
                        color: '#000',
                        top: 18,
                        left: 7,
                        blur: 10,
                        opacity: 0.2
                    },
                    toolbar: {
                        show: false
                    }
                },
                colors: ['#77B6EA', '#545454', '#FEBC3B', "#51CBCE"],
                dataLabels: {
                    enabled: true,
                    formatter: function (value) {
                        return value.toLocaleString("pt-BR", { maximumFractionDigits: 2, style: 'decimal' });
                    },
                    background: {
                        enabled: true,
                        //foreColor: ['#77B6EA', '#545454', '#FEBC3B', 'transparent'],
                        borderWidth: 1,
                    },
                },
                stroke: {
                    curve: 'smooth'
                },
                title: {
                    text: 'Total',
                    align: 'left'
                },
                grid: {
                    borderColor: '#e7e7e7',
                    row: {
                        colors: ['#f3f3f3', 'transparent'],
                        opacity: 0.5
                    },
                },
                markers: {
                    size: 1
                },
                xaxis: {
                    categories: ["JAN", "FEV", "MAR", "ABR", "MAI", "JUN", "JUL", "AGO", "SET", "OUT", "NOV", "DEZ"],
                    title: {
                        text: 'Mês'
                    }
                },
                yaxis: {
                    title: {
                        text: 'TOTAL'
                    },
                    //min: 5,
                    //max: 40,
                    //opposite: true,
                    labels: {
                        formatter: function (value) {
                            if (Number.isFinite(value)) {
                                return value.toLocaleString("pt-BR", { maximumFractionDigits: 2, style: 'decimal' });
                            }
                            else {
                                return 0
                            }
                        }

                    }
                },
                legend: {
                    position: 'top',
                    horizontalAlign: 'right',
                    floating: true,
                    offsetY: -25,
                    offsetX: -5,
                    formatter: function(seriesName, opts) {
                        seriesName = seriesName === "Total" ? "Total" : seriesName;
                        return [seriesName]
                    }
                }
            }

        }
    }

    async componentDidMount() {
        await this.loadMetas();
        this.calculaTipoPorMes();
    }

    loadMetas = async () => {
        let metas = await api.get("/metasformatadas");
        this.setState({ metas: metas.data.metas });
    }

    calculaTotalParaProximoAno = (meses, metasFiltradas, selectCampo) => {
        let resultTotal = meses.map(mes => utils.total(metasFiltradas, mes)[selectCampo]);
        return resultTotal
    }

    calculaTipoPorMes = (event) => {
        let { metas, selectCampo, modalidade, unidade } = this.state

        let tipo = ["Pago", "Gratuidade Regimental", "Gratuidade Não-Regimental"];

        let filtros = {
            unidade: unidade,
            tipo: "Pago",
            modalidade: modalidade
        }

        if (Boolean(event)) {
            let evento = event.target.value;

            if(event.target.id === "selectUnidade") {
                filtros.unidade = evento
                unidade = evento
            }
            if (event.target.id === "selectCampo") {
                selectCampo = evento;
            }
            if (event.target.id === "selectModalidade") {
                filtros.modalidade = evento
                modalidade = evento
            }
        }

        if (modalidade === "Todas") delete filtros.modalidade;
        if (unidade === "Todas") delete filtros.unidade;

        let resultTotalHoras = [];

        let dados = tipo.map(tipo => {
            filtros.tipo = tipo;
            let meses = ["JAN", "FEV", "MAR", "ABR", "MAI", "JUN", "JUL", "AGO", "SET", "OUT", "NOV", "DEZ"];
            let metasFiltradas = utils.filtrar(metas, filtros);
            let resultados = meses.map(mes => utils.total(metasFiltradas, mes)[selectCampo]);

            // horas que entrarão para o próximo ano
            if(selectCampo == 6) {

                // Total de horas
                let totalHoraAluno = this.calculaTotalParaProximoAno(meses, metasFiltradas, 4) 
                // horaAlunoDistribuida
                let resultHoraAlunoDistrib = this.calculaTotalParaProximoAno(meses, metasFiltradas, 5)
                // horaAlunoDistribuidaPercentualEvasao
                let totalDistr2024Percent = resultados.reduce((acc, atual) => acc + atual, 0)

                totalHoraAluno = totalHoraAluno.reduce((acc, atual) => acc + atual, 0)
                resultHoraAlunoDistrib = resultHoraAlunoDistrib.reduce((acc, atual) => acc + atual, 0)

                let percentual = resultHoraAlunoDistrib !== 0 ? totalDistr2024Percent / resultHoraAlunoDistrib : 1

                let totalProximoAno = totalHoraAluno - totalDistr2024Percent

                resultTotalHoras.push(Math.floor(totalProximoAno * percentual))

            }
            // fim

            return resultados
        });

        //Componente Pai
        this.props.totais(dados)
        //===
        
        let total = new Array(12).fill(0);
        total = total.map((valor, index) => {
            return dados[0][index] + dados[1][index] + dados[2][index]
        });

        this.setState({
            horaAlunoProximosAnos: resultTotalHoras,
            series: [
                {
                    name: "Pago",
                    data: dados[0]
                },
                {
                    name: "Gratuidade Regimental",
                    data: dados[1]
                },
                {
                    name: "Gratuidade Não-Regimental",
                    data: dados[2]
                },
                {
                    name: "Total",
                    data: total,
                }
            ],
            options: {
                title: {
                    text: `${unidade === "Todas" ? "DR" : unidade}`
                }
            },
            modalidade: modalidade,
            unidade: unidade,
            selectCampo: selectCampo,
            nomeCampo: this.informaCampo(selectCampo)
        })
    }

    informaCampo = (selectCampo) => {
        var propriedades = [
            "N.° de Turmas",
            "Mat. Residuais",
            "Mat. Novas",
            "Total Mat.",
            "Hora/aluno",
            "Hora/aluno Distribuida",
            "Hora/aluno Distribuida (% evasão)",
        ]
        return propriedades[selectCampo]
    }

    formatNumber = (value) => {
        return value.toLocaleString("pt-BR", { maximumFractionDigits: 2, style: 'decimal' })
    }

    render() {
        let { horaAlunoProximosAnos } = this.state
        return (
            <Fragment>

                <div className="row">
                    <div className="col-md-12">
                        <div className="card ">
                            <div className="card-header ">
                                <div className="row">
                                    <div className="col-md-6">
                                        <h5 className="card-title">{this.state.nomeCampo}</h5>
                                        <h6>{this.state.modalidade}</h6>
                                    </div>
                                    <div className="col-md-2">
                                        <Select selectUnidade={this.calculaTipoPorMes} />
                                    </div>
                                    <div className="col-md-2">
                                        <SelectCampo selectCampo={this.calculaTipoPorMes} />
                                    </div>
                                    <div className="col-md-2">
                                        <SelectModalidade selectModalidade={this.calculaTipoPorMes} />
                                    </div>
                                </div>
                            </div>
                            <div className="card-body ">
                                <div className="mixed-chart">
                                    <Chart options={this.state.options} series={this.state.series} type="line" height={"300"} />
                                </div>
                                {
                                    horaAlunoProximosAnos.length > 0 ?
                                    <Fragment>
                                        <div className="d-flex justify-content-center">
                                            <div><b>Hora/aluno que restarão para 2027-2028</b></div>
                                        </div>
                                        <div className="d-flex justify-content-center mt-2">
                                            <div><b>Gratuidade Regimental:</b> {this.formatNumber(horaAlunoProximosAnos[1])} | <b>Gratuidade Não-Regimental:</b> {this.formatNumber(horaAlunoProximosAnos[2])} | <b>Pagos:</b> {this.formatNumber(horaAlunoProximosAnos[0])}</div>
                                        </div>
                                        <div className="d-flex justify-content-center mt-2">
                                            <div><b>Total:</b> {this.formatNumber(horaAlunoProximosAnos[0] + horaAlunoProximosAnos[1] + horaAlunoProximosAnos[2])}</div>
                                        </div>
                                    </Fragment>
                                    :
                                    null
                                }
                            </div>
                            <div className="card-footer ">
                                <hr />
                                <div className="stats">
                                    <i className="fa fa-history"></i> {new Date().toLocaleDateString("pt-br", { dateStyle: "full" })}
                                    <span style={{ float: 'right' }}>
                                        <button className="btn btn-outline-primary btn-round btn-sm" style={{ fontSize: '0.500em' }} onClick={() => this.props.escolheDash()}>
                                            Visão Unidades
                                        </button>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </Fragment>
        )
    }
}